import { Card, CardProps } from '@blueprintjs/core';
import classes from './WorkingListCard.module.css';
import { classNames } from '../../utils/classNames';

interface Props extends CardProps {
  highlighted?: boolean;
  disabled?: boolean;
}

export function WorkingListCard({
  highlighted,
  disabled,
  className,
  ...props
}: Props) {
  return (
    <Card
      data-highlighted={highlighted}
      data-disabled={disabled}
      elevation={getElevation(disabled ?? false, highlighted ?? false)}
      className={classNames(classes.card, className)}
      {...props}
    />
  );
}

function getElevation(disabled: boolean, highlighted: boolean) {
  if (disabled) {
    return 0;
  }

  if (highlighted) {
    return 2;
  }

  return 1;
}
